var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    fill: "#e363a8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), "className=\n\n", _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .puchipuchi_een{fill:#e363a8;} "), /*#__PURE__*/React.createElement("path", {
    className: "puchipuchi_een",
    d: "M6,11h4.78c0.549-0.609,1.337-1,2.22-1h8V5c0-1.1-0.9-2-2-2H3C1.9,3,1,3.9,1,5v11c0,1.1,0.9,2,2,2h4 l3,3v-8H6c-0.552,0-1-0.448-1-1S5.448,11,6,11z M6,7h10c0.552,0,1,0.448,1,1s-0.448,1-1,1H6C5.448,9,5,8.552,5,8S5.448,7,6,7z M29,11H13c-1.1,0-2,0.9-2,2v11c0,1.1,0.9,2,2,2h5l3,3l3-3h5c1.1,0,2-0.9,2-2V13C31,11.9,30.1,11,29,11z M26,21H16 c-0.552,0-1-0.448-1-1s0.448-1,1-1h10c0.552,0,1,0.448,1,1S26.552,21,26,21z M26,17H16c-0.552,0-1-0.448-1-1s0.448-1,1-1h10 c0.552,0,1,0.448,1,1S26.552,17,26,17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSvgrepoCom);
export default __webpack_public_path__ + "static/media/chat-svgrepo-com.96d2cd9a59eb3969259d68ec87261f38.svg";
export { ForwardRef as ReactComponent };